function showSuccess(step, name) {
  const form = MultiStepForm[step];
  if (!form.hasOwnProperty(name)) {
    return;
  }

  jQuery(`.field-LeadForm-${name}`).addClass("has-success")
  jQuery(`.field-LeadForm-${name}`).removeClass("has-error")

  var feedback = document.getElementById(`error_${name}`)
  if (feedback) {
    feedback.innerHTML = ""
  }
  form[name] = true
}

function showError(step, name, field, value, override = "") {
  const form = MultiStepForm[step]
  if (!form.hasOwnProperty(name)) {
    return
  }

  jQuery(`.field-LeadForm-${name}`).addClass("has-error")
  jQuery(`#error_${name}`).removeClass("d-none")

  let text = `Por favor, ingresa un ${field} válido.`
  if (value == "") {
    text = `Por favor, ingresa tu ${field}.`
  }

  if (override && override !== "") {
    text = override
  }

  let errorElm = document.getElementById(`error_${name}`)
  if(errorElm){
    errorElm.innerHTML = text
  }
  form[name] = false
}

function validateForm(step) {
  if (step == 1) {
    triggerStep1Elements()
  } else if (step == 2) {
    triggerStep2Elements()
  } else if (step == 3) {
    triggerStep3Elements()
  } else if (step == 4) {
    triggerStep4Elements()
  } else if (step == 5) {
    triggerStep5Elements()
  }

  const form = MultiStepForm[step]
  if (!Object.values(form).every((field) => field)) {
    return false
  }

  return true
}

const triggerStep1Elements = () => {
  recaptchaCallback()

  jQuery("#form-input-step-1 input").trigger("keyup")
  jQuery("#form-checkbox-step-1 input").trigger("change")
}

const triggerStep2Elements = () => {
  jQuery("#form-input-step-2 input").trigger("keyup")
  jQuery("#form-selector-step-2 select").trigger("change")
}

const triggerStep3Elements = () => {
  jQuery("#form-selector-step-3 select").trigger("change")
  jQuery("#form-date-step-3 select").trigger("change")
  jQuery("#form-toggle-step-3 #LeadForm-gender").trigger("change")
  jQuery("#form-toggle-step-3 #LeadForm-phone_plan").trigger("change")
}

const triggerStep4Elements = () => {
  jQuery("#form-input-step-4 input").trigger("keyup")
  jQuery("#form-selector-step-4 select").trigger("change")
  jQuery("#form-date-step-4 select").trigger("change")
  jQuery("#form-toggle-step-4 #LeadForm-car_owner").trigger("change")
  jQuery("#form-input-step-4 #LeadForm-car_plate_number").trigger("keyup")
}

const triggerStep5Elements = () => {
  jQuery("#form-input-step-5 input").trigger("keyup")
}
